import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AppRoutes from './routes/AppRoutes';
import { NavigationGuardProvider } from './contexts/NavigationGuardContext';
import { MobileDrawerProvider } from './contexts/MobileDrawerContext';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <NavigationGuardProvider>
          <MobileDrawerProvider>
            <AppRoutes />
          </MobileDrawerProvider>
        </NavigationGuardProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
